import React, { Component } from "react";
import { connect } from "react-redux";
import { Pencil } from "react-bootstrap-icons";
import moment from "moment";
import styles from "./Profile.styles";

import * as actions from "../../../redux/user/actions";

import type User from "../../models/User";

import ProfileModal from "../components/modals/profile-modal/ProfileModal";
import ProjectImage from "../components/project-image/ProjectImage";
import { isMobile } from "../../../helpers/Utils";

type Props = {
  user: User,
};

type State = {
  showUserModal: boolean,
};

class Profile extends Component {
  props: Props;
  state: State = {
    showUserModal: false,
  };

  openUserModal = () => {
    this.setState({
      showUserModal: true,
    });
  };

  closeUserModal = () => {
    this.setState({
      showUserModal: false,
    });
  };

  render() {
    return (
      <div className="profile-content">
        <div className="profile-title-container">
          <h1 className="project-title">Profile</h1>
          <div
            className="profile-edit-button"
            onClick={() => this.openUserModal()}
          >
            <Pencil size="20" />
          </div>
        </div>
        {this.renderUserInfo()}
        {this.state.showUserModal ? this.renderUserModal() : null}
      </div>
    );
  }

  renderUserInfo() {
    return (
      <div className="profile-info-container deuppercase-children">
        <ProjectImage
          url={this.props.user.avatarURL}
          width={250}
          height={250}
        />
        <h2 style={styles.secondaryTitle} className="m-t-15">
          {this.props.user.firstName} {this.props.user.lastName}
        </h2>
        <div>
          <div className="label">
            Email: <div className="value">{this.props.user.email}</div>
          </div>
        </div>
        <div>
          <div className="label">
            Company: <div className="value">{this.props.user.name}</div>
          </div>
        </div>
        <div>
          <div className="label">
            Timezone:{" "}
            <div className="value">
              {this.props.user.timezone
                ? this.props.user.timezone
                : "Unspecified"}
            </div>
            {this.props.user.timezone !== moment.tz.guess() && (
              <div style={{ color: "red" }}>
                <div>Mismatched timezone!</div>
                <div>Suggested: {moment.tz.guess()}</div>
              </div>
            )}
          </div>
        </div>
        {isMobile() && (
          <div>
            <div className="label">
              Notice:{" "}
              <div className="value">
                Use the website to further manage your account.
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderUserModal = () => {
    return (
      <ProfileModal
        user={this.props.user}
        updateUser={this.props.updateUser}
        onModalClose={() => this.closeUserModal()}
      />
    );
  };
}

const mapStateToProps = (_state) => {
  return {};
};

export default connect(mapStateToProps, actions)(Profile);



// WEBPACK FOOTER //
// ./src/views/user/profile/Profile.js